import { WarningIcon } from 'assets/icons'

const FallbackError = ({ type, className = '' }) => (
  <div
    className={`bg-white flex flex-col items-center p-4 rounded-md border border-gray-500 w-full mt-4 ${className}`}
  >
    <span className='rounded-full h-10 w-10 items-center justify-center bg-yellow-100 flex'>
      <WarningIcon />
    </span>
    <p className='text-xs font-bold mt-2'>No pudimos cargar {type}</p>
    <p className='text-2xs text-gray-900 font-medium mt-1'>
      Por favor, intentá de nuevo más tarde.
    </p>
  </div>
)

export default FallbackError
